const value = {
  metrics: {
    averageProgress: {
      label: 'Прогресс компании',
    },
    averageProgressProject: {
      label: 'Средний прогресс по проекту',
    },
    averageScore: {
      label: 'Средний балл',
    },
    activeUsers: {
      label: 'Активные пользователи',
      tooltip: 'Активные пользователи — те, кто открыл хотя бы один обязательный юнит',
    },
    completedUsers: {
      label: 'Завершили обязательные юниты',
    },
  },
};

export default value;
